import { render } from "./template.default.vue?vue&type=template&id=c68a9d8c"
import script from "./template.default.vue?vue&type=script&lang=js"
export * from "./template.default.vue?vue&type=script&lang=js"

import "./template.default.vue?vue&type=style&index=0&id=c68a9d8c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__